var _defs, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 80",
    height: 80,
    width: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #928980;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #4cb0d3;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.39,39.32h-34.7v26.3h30.5c2.3,0,4.2-1.9,4.2-4.2,0,0,0-22.1,0-22.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.99,39.62H19.19v28.7c0,1.6,1.3,2.8,2.8,2.8h111.2c1.6,0,2.8-1.3,2.8-2.8v-28.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.79,
    y: 38.52,
    width: 6.4,
    height: 18.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "172.89 65.32 172.89 40.12 164.19 40.32 164.19 61.02 152.19 61.02 152.19 65.52 172.89 65.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.39,41.32h-34.7V15.02h30.5c2.3,0,4.2,1.9,4.2,4.2v22.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.99,41.02H19.19V12.22c0-1.6,1.3-2.8,2.8-2.8h111.2c1.6,0,2.8,1.3,2.8,2.8v28.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.79,
    y: 23.52,
    width: 6.4,
    height: 18.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "172.89 15.32 172.89 40.52 164.19 40.32 164.19 19.62 152.19 19.62 152.19 15.12 172.89 15.32"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 168.17,
    y: 8.29,
    width: 3.71,
    height: 5.96,
    transform: "translate(9.8 69.27) rotate(-23.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 166.53,
    y: 67.04,
    width: 6.78,
    height: 3.34,
    transform: "translate(25.45 181.51) rotate(-60)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M136.19,23.02V11.52l-2-2.5H21.19l-2,1.5v58l2,2.5h113l2-2.5v-11.5m0-34h6m-6,0V57.02m6-34V57.02m0-34v-4m35.5,42l-.5,2.5-2.62,1.5m3.12-4l-.09-7.5m-41.41,3.5h6m0,0v4.25m0,0v4.25h10m-10-4.25l10-.11m12.5-.14l-12.5,.14m12.5-.14l9,4-.12-25.12m-8.88,21.12v-21m0-21l9.5-4m-9.5,4h-12.5m12.5,0v21m-22.5-21v-4.5h10m-10,4.5h10m22-4l1.5,.5,1.5,2,.03,2.5m-3.03-5l-.75-.25m.75,.25l-3-6-2.5-1.5-2.5,1.5,2,5m-16,5v-4.5m0,0h20.5l.75,.25m-21.25,46.39v4.36m0,0h16.5m4.75-50.75l.12,25.12m0,0l-8.88,.12m4,25.5h5l.88-.5m-5.88,.5l-2.5,5,2.5,1.5,2.5-1.5,3.38-5.5m2.65-45l.08,7m0,0l.31,26.5m2.88-24.48h-1.39v-6.38h1.39v6.38Zm.33,25.58h-1.39v-6.38h1.39v6.38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.c211e2d01d69e49921317c8293867deb.svg";
export { ForwardRef as ReactComponent };